module.exports = __webpack_public_path__ + "media/vid_top_case4.3dd9b5a9.mp4";